export const isDev = () => {
  return import.meta.env.DEV;
};

export const getEndPoint = () => {
  return import.meta.env.VITE_API_ENDPOINT;
};
